import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

import { Fancybox } from '@fancyapps/ui/dist/fancybox/';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
const isDesktop = window.innerWidth > 1024;

document.addEventListener('DOMContentLoaded', () => {
  new Swiper('.preview-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 10,
    speed: 800,

    navigation: {
      nextEl: '.projects-next',
      prevEl: '.projects-prev',
    },

    roundLengths: true,
    slidesOffsetBefore: isDesktop ? 30 : 20,
    slidesOffsetAfter: isDesktop ? 30 : 20,
  });

  Fancybox.bind('[data-fancybox="projects"]', {
    Carousel: {
      Toolbar: {
        display: {
          left: [],
          middle: [],
          right: ['close'],
        },
      },

      Thumbs: {
        type: 'classic',
      },
    },
  });
});
